import { PropertyValueSet } from "@genesys/property";
import {
  PropertyDefinitions,
  getDefaultCaseOverrides,
  getAllPropertyUpdates
} from "../../../tools";
import { Defaults } from "./types";
import { TopLevelOverrides } from "../../";
import * as KnownProperties from "../../../tools/known-properties";
import * as SharedState from "../../../../shared-state";
import * as GraphQLTypes from "../../../../graphql-types";
import * as ClimateSelectorKnownProps from "../../../../climate-selector/known-properties";
import * as ClimateSelector from "../../../../climate-selector";

export function getDefaults(
  productQuery: GraphQLTypes.MoistureLoadCalculationProductQuery,
  sharedState: SharedState.State,
  propertyDefinitions: PropertyDefinitions,
  moistureLoadUserSettings: PropertyValueSet.PropertyValueSet,
  topLevelProperties: ReadonlyArray<string>,
  topLevelCaseOverrideProperties: ReadonlyArray<TopLevelOverrides>
): Defaults {
  const moistureLoadRules = productQuery.product.moistureLoadRules;

  const userMoistureLoadSettingsToKeep = [
    KnownProperties.applicationType,
    KnownProperties.buildingStructure
  ];

  const filteredUserSettings = PropertyValueSet.keepProperties(
    userMoistureLoadSettingsToKeep,
    moistureLoadUserSettings
  );

  const defaultMainSettings = PropertyValueSet.fromString(
    moistureLoadRules.defaultSettings
  );

  const mergedSettings = PropertyValueSet.merge(
    filteredUserSettings,
    defaultMainSettings
  );

  const propertiesToUpdate = getAllPropertyUpdates(
    defaultMainSettings,
    mergedSettings,
    propertyDefinitions,
    true
  );

  const loadCreationProperties = PropertyValueSet.merge(
    propertiesToUpdate,
    mergedSettings
  );

  const defaultMoistureLoadSettings = PropertyValueSet.keepProperties(
    topLevelProperties,
    loadCreationProperties
  );

  const topLevelCaseOverridePropertiesToKeep =
    topLevelCaseOverrideProperties.flatMap(x => {
      const isOverriden =
        PropertyValueSet.getInteger(
          x.useProperty,
          defaultMoistureLoadSettings
        ) === 1;
      return isOverriden ? x.overridableProperties : [];
    });

  const defaultMainSettingsOverrides = getDefaultCaseOverrides(
    PropertyValueSet.keepProperties(
      topLevelCaseOverridePropertiesToKeep,
      defaultMoistureLoadSettings
    )
  );

  const defaultClimateSettings = ClimateSelector.getDefaultClimateSettings(
    sharedState,
    getDefaultDataTypes(),
    productQuery.product.dataPointsForLocationId!,
    productQuery.product.countries
  );
  return {
    loadCreationProperties,
    defaultMainSettingsOverrides,
    defaultMoistureLoadSettings,
    defaultClimateSettings
  };
}

function getDefaultDataTypes() {
  const defaultDataTypes = PropertyValueSet.Empty;
  return PropertyValueSet.setText(
    ClimateSelectorKnownProps.manualData.coolingDataType,
    "DP/MCDB",
    defaultDataTypes
  );
}
